import { Component, effect, OnDestroy } from '@angular/core';
import { AppService } from '../app.service';
import { LegalAgreementsService } from './legal-agreements.service';

@Component({
  selector: 'app-legal-agreement',
  standalone: false,
  templateUrl: './legal-agreement.component.html',
  styleUrls: ['./legal.component.css', './legal-agreement.component.css']
})
export class LegalAgreementComponent implements OnDestroy {
  termsAccepted = false;
  privacyAcknowledged = false;
  busy = false;
  error = '';
  // Only shown once loading has taken a noticeable amount of time, so a fast
  // check doesn't flash a loading indicator over the app for an instant.
  showLoadingIndicator = false;
  private displayedVersion?: string;
  private loadingIndicatorTimer?: ReturnType<typeof setTimeout>;

  constructor(protected legal: LegalAgreementsService, protected app: AppService) {
    effect(() => {
      const version = this.legal.documents()?.version;
      if (version !== this.displayedVersion) {
        this.displayedVersion = version;
        this.termsAccepted = false;
        this.privacyAcknowledged = false;
        this.error = '';
      }
    });
    effect(() => {
      clearTimeout(this.loadingIndicatorTimer);
      if (this.legal.loading()) {
        this.loadingIndicatorTimer = setTimeout(() => this.showLoadingIndicator = true, 300);
      } else {
        this.showLoadingIndicator = false;
      }
    });
  }

  async accept(): Promise<void> {
    const version = this.legal.documents()?.version;
    if (!version || !this.termsAccepted || !this.privacyAcknowledged || this.busy) {
      this.error = 'Please agree to the Terms of Use and acknowledge the Privacy Policy.';
      return;
    }
    this.busy = true;
    this.error = '';
    try {
      await this.legal.accept(version);
    } catch (error) {
      console.error('Legal acceptance failed:', error);
      await this.legal.refresh();
      this.error = 'Your agreement was not confirmed. Review the current documents and try again.';
    } finally {
      this.busy = false;
    }
  }

  ngOnDestroy(): void {
    clearTimeout(this.loadingIndicatorTimer);
  }
}
